'use client';

import React from 'react';

interface ExploreSectionProps {
  onNavigate: (page: string) => void;
}

const ExploreSection: React.FC<ExploreSectionProps> = ({ onNavigate }) => {
  const cards = [
    {
      icon: '👩‍🏫',
      title: 'Our Tutors',
      desc: 'Meet our expert tutors and find the perfect match for your learning goals.',
      page: 'tutors',
    },
    {
      icon: '⭐',
      title: 'Reviews',
      desc: 'See what students and parents are saying about their Stellar Scholar experience.',
      page: 'reviews',
    },
    {
      icon: '🛍️',
      title: 'Shop',
      desc: 'Browse our tutoring packages and resources to find the right fit for your budget.',
      page: 'shop',
    },
    {
      icon: '✏️',
      title: 'Sign Up',
      desc: "Ready to get started? Sign up and we\'ll match you with a tutor within 24 hours.",
      page: 'signup',
    },
  ];

  return (
    <section
      className="explore-section"
      style={{
        padding: '4rem 1.5rem',
        maxWidth: 1200,
        margin: '0 auto',
        position: 'relative',
        zIndex: 1,
      }}
    >
      <div className="section-label">Explore Our Site</div>
      <h2
        className="section-title"
        style={{ fontFamily: "'Playfair Display', serif" }}
      >
        Everything You Need,
        <br />
        All in One Place.
      </h2>
      <div className="gold-line" />

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
          gap: '1.25rem',
          marginTop: '2rem',
        }}
      >
        {cards.map((card) => (
          <div
            key={card.title}
            className="subject-card explore-card"
            onClick={() => onNavigate(card.page)}
          >
            <div style={{ fontSize: '2rem', marginBottom: '0.75rem' }}>{card.icon}</div>
            <h3
              style={{
                fontFamily: "'Playfair Display', serif",
                fontSize: '1.15rem',
                marginBottom: '0.5rem',
                color: '#ffffff',
              }}
            >
              {card.title}
            </h3>
            <p style={{ fontSize: '0.88rem', color: 'rgba(255,255,255,0.55)', lineHeight: 1.6 }}>
              {card.desc}
            </p>
          </div>
        ))}
      </div>

      <style>{`
        @media (max-width: 640px) {
          .explore-card {
            padding: 1.25rem !important;
          }
        }
      `}</style>
    </section>
  );
};

export default ExploreSection;
